// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__8w2NK","content":"Layout_content__88Srk"};